/**
 * Asynchronously loads the component for CompanyProfile
 */

import { lazyLoad } from "utils/loadable";

export const AdminProfile = lazyLoad(
  () => import("./index"),
  (module) => module.AdminProfile
);
